<template>
  <v-dialog v-model="dialog" max-width="500px" persistent>
    <v-card>
      <v-card-title class="headline">Edit Trust Effective Date</v-card-title>
      <v-card-text>
        <v-form ref="form" v-model="valid">
          <p class="mb-3">
            Update the trust effective date for <strong>{{ memberName }}</strong>
          </p>
          <v-menu
            v-model="menu"
            :close-on-content-click="false"
            transition="scale-transition"
            offset-y
            min-width="auto"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-model="newDate"
                label="Trust Effective Date"
                prepend-icon="mdi-calendar"
                readonly
                v-bind="attrs"
                v-on="on"
                :rules="dateRules"
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="newDate"
              @input="menu = false"
              :max="maxDate"
            ></v-date-picker>
          </v-menu>
          <p class="text-caption text--secondary">
            Current value: {{ currentDate }}
          </p>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="grey darken-1" text @click="close">Cancel</v-btn>
        <v-btn 
          color="primary" 
          :disabled="!valid || loading" 
          :loading="loading"
          @click="save"
        >
          Save
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "EditTrustEffectiveDateDialog",
  props: {
    value: Boolean,
    username: {
      type: String,
      required: true
    },
    memberName: {
      type: String,
      default: ''
    },
    currentDate: {
      type: String,
      default: ''
    }
  },
  data: () => ({
    valid: false,
    loading: false,
    menu: false,
    newDate: '',
    maxDate: new Date().toISOString().substr(0, 10),
    dateRules: [
      v => !!v || 'Date is required',
    ]
  }),
  computed: {
    dialog: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      }
    }
  },
  watch: {
    value(newVal) {
      if (newVal && this.currentDate) {
        // Parse the current date to extract just the date part
        const datePart = this.currentDate.split(' ')[0];
        // Try different date formats
        if (datePart) {
          // If it's in "Month DD, YYYY" format, convert it
          const date = new Date(datePart);
          if (!isNaN(date.getTime())) {
            this.newDate = date.toISOString().substr(0, 10);
          } else {
            // Try parsing as "Month DD, YYYY" format
            const parsedDate = this.parseDisplayDate(this.currentDate);
            if (parsedDate) {
              this.newDate = parsedDate;
            }
          }
        }
      }
    }
  },
  methods: {
    parseDisplayDate(dateStr) {
      // Parse dates like "October 10, 2025" to "2025-10-10"
      try {
        const date = new Date(dateStr);
        if (!isNaN(date.getTime())) {
          return date.toISOString().substr(0, 10);
        }
        return null;
      } catch (e) {
        return null;
      }
    },
    close() {
      this.dialog = false;
      this.$refs.form.reset();
    },
    async save() {
      if (!this.$refs.form.validate()) {
        return;
      }

      this.loading = true;
      try {
        const response = await this.$axios.patch(`/admin/user/trustEffectiveDate`, {
          trust_effective_date: this.newDate,
          username: this.username
        });

        this.$emit('updated', {
          oldDate: response.data.old_date,
          newDate: response.data.new_date
        });
        
        this.$emit('success', response.data.message);
        this.close();
      } catch (error) {
        const errorMessage = error.response?.data?.message || 'Failed to update trust effective date';
        this.$emit('error', errorMessage);
      } finally {
        this.loading = false;
      }
    }
  }
};
</script>

